import { Shield, Clock, ArrowRight } from "lucide-react";

export const SpfDkimDmarcHeroSection = () => {
  return (
    <section className="pt-24 sm:pt-28 pb-8 sm:pb-10">
      <div className="text-center max-w-4xl mx-auto px-4">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-medium mb-6">
          <Shield className="w-4 h-4" />
          Technical Guide
        </div>
        
        <h1 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold text-foreground mb-4 leading-tight">
          SPF, DKIM & DMARC: The Complete Technical Guide
        </h1>
        
        <p className="text-lg sm:text-xl text-muted-foreground mb-6 max-w-2xl mx-auto">
          Authentication protocols demystified — understand how these three layers work together to protect your sender reputation and maximize inbox placement
        </p>
        
        <div className="flex items-center justify-center gap-4 text-sm text-muted-foreground">
          <span className="flex items-center gap-1.5">
            <Clock className="w-4 h-4" />
            12 min read
          </span>
          <span>•</span>
          <span>Updated January 2025</span>
        </div>

        <div className="grid grid-cols-3 gap-4 mt-10 max-w-lg mx-auto">
          <div className="bg-card rounded-xl border border-border p-4">
            <p className="text-2xl sm:text-3xl font-bold text-primary">SPF</p>
            <p className="text-xs text-muted-foreground mt-1">Sender Policy</p>
          </div>
          <div className="bg-card rounded-xl border border-border p-4">
            <p className="text-2xl sm:text-3xl font-bold text-primary">DKIM</p>
            <p className="text-xs text-muted-foreground mt-1">Digital Signature</p>
          </div>
          <div className="bg-card rounded-xl border border-border p-4">
            <p className="text-2xl sm:text-3xl font-bold text-primary">DMARC</p>
            <p className="text-xs text-muted-foreground mt-1">Alignment</p>
          </div>
        </div>
      </div>
    </section>
  );
};
